import { Component, OnInit, ViewChild, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { MatDrawer } from '@angular/material/sidenav';
import { AppConstants } from './app-constants';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    readonly en = 'en';
    readonly fr = 'fr';
    @ViewChild('drawer')
    drawer: MatDrawer;
    private subscription: Subscription = Subscription.EMPTY;
    today: number;

    constructor(
        private translate: TranslateService,
        private router: Router,
        private titleService: Title,
        @Inject(PLATFORM_ID) private platformId: {}
    ) {
        this.today = new Date().getFullYear();
        if (isPlatformBrowser(this.platformId)) {
            const lang = localStorage.getItem(AppConstants.LOCALE_LANGUAGE);
            this.translate.setDefaultLang(lang);
        }
    }

    ngOnInit(): void {
        this.subscription = this.router.events.subscribe((event) => this.toggle(event));

    }

    closeDrawer(): void {
        this.drawer.close();
    }

    private toggle(event: any) {
        switch (event.constructor) {
            case NavigationEnd:
                this.setTitle();
                this.closeDrawer();
                break;
            default:
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    switchToEnglish(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(AppConstants.LOCALE_LANGUAGE, this.en);
        }
        this.translate.use(this.en);
        this.setTitle();
    }

    switchToFrench(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(AppConstants.LOCALE_LANGUAGE, this.fr);
        }
        this.translate.use(this.fr);
        this.setTitle();
    }

    private setTitle(): void {
        const title = this.router.routerState.snapshot.root.firstChild.data.title as string;
        if (title) {
            this.translate.get(title).subscribe(translation => this.titleService.setTitle(translation as string));
        }
    }
}
